import axios from "../plugins/parseAxios";

export class ExpenseApi {
  static createExpense(formData) {
    return axios.post("functions/createExpense", formData);
  }
  static updateExpense(formData) {
    return axios.post("functions/updateExpense", formData);
  }
  static removeExpense(id) {
    return axios.post("functions/removeExpense", { id });
  }
  static getExpense(id) {
    return axios.post("functions/getExpense", { id });
  }
  static getExpenseBetweenDateByMarket(formData) {
    return axios.post("functions/getExpenseBetweenDateByMarket", formData);
  }
}